import React from 'react';
import Hero from '../components/Hero';
import TeaserBanner from '../components/TeaserBanner';
import Newsletter from '../components/Newsletter';
import Footer from '../components/Footer';

export default function Home() {
  return (
    <>
      <Hero />
      <TeaserBanner />
      <Newsletter />
      <Footer />
    </>
  );
}